import React from 'react';
import { Button } from 'semantic-ui-react';

const ELEMENT_PROPS = {
  Button: {
    primary: true,
  },
};

const ELEMENT_TYPES = {
  span: <span />,
  p: <p />,
  a: <a />,
  Button: <Button />,
};

export default ({ linkAs, title, ...rest }) => {
  return React.cloneElement(getLinkElement(linkAs), {
    children: title,
    ...getElementProps(linkAs),
    ...rest,
  });
};

function getElementProps(linkAs) {
  return ELEMENT_PROPS[linkAs] || {};
}

function getLinkElement(linkAs) {
  return ELEMENT_TYPES[linkAs] || ELEMENT_TYPES.span;
}
